<div class="container-fluid" id="container-wrapper" style="background-color: white;" *ngIf="userType=='Admin'">
    <div class="d-sm-flex align-items-center justify-content-between mb-4" style="border-bottom:2px solid grey;">
        <h1 class="h3 mb-0 text-gray-800">Lead Status</h1>
    </div>
    <div class="row" id="dataArea" #dataArea style="margin-top: 10px!important;overflow-y: scroll !important;overflow-x: hidden;height: 570px;">
        <div class="div-viewport">
            <div class="grid12">
                <table class="table table-sm table-hover " style="padding-right: 20px!important;">
                    <tr style="background-color: blue;color: white;">
                        <th>#</th>
                        <th>Lead Status</th>
                        <th>Color Scheme</th>
                        <th>Followup</th>

                        <th></th>
                    </tr>
                    <tbody id="myTable">
                        <tr *ngFor="let item of pagedItems;let counter=index;">
                            <td>{{counter+1}}</td>
                            <td>{{item.statusName}}</td>
                            <td>{{item.colorScheme}}</td>
                            <td>{{item.followupRequired}}</td>
                            <th style="max-width: 20px!important;">
                                <li class="nav-item dropdown no-arrow mx-1" style="right: 12px;">
                                    <a class="nav-link" href="#" id="alertsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right shadow " aria-labelledby="alertsDropdown">
                                        <a class="dropdown-item d-flex align-items-center" (click)="openEditDialog(item.refNo)">
                                            <div class="mr-3">
                                                <div class="icon-circle bg-success">
                                                    <i class="fas fa-edit text-white"></i>

                                                </div>
                                            </div>
                                            <div>
                                                Edit Lead Status
                                            </div>
                                        </a>
                                        <a class="dropdown-item d-flex align-items-center" (click)="deleteClick(item.refNo)">
                                            <div class="mr-3">
                                                <div class="icon-circle bg-warning">
                                                    <i class="fas fa-male text-white"></i>
                                                </div>
                                            </div>
                                            <div>
                                                Delete Lead Status
                                            </div>
                                        </a>
                                    </div>
                                </li>
                            </th>
                        </tr>
                        <tr>
                            <th colspan="4" *ngIf="pagedItems?.length==0">No data found !</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- ======== PAGINATION ======== -->
    <div class="pagination-wrapper" *ngIf="pager.pages && pager.pages.length">
        <ul class="pagination">
            <li [class.disabled]="!pager.hasPreviousPage">
                <a (click)="setPage(1)" class="page-link">First</a>
            </li>
            <li [class.disabled]="!pager.hasPreviousPage">
                <a (click)="setPage(pager.currentPage - 1)" class="page-link">Prev</a>
            </li>
            <li *ngFor="let page of pager.pages" [class.active]="pager.currentPage === page">
                <a (click)="setPage(page)" class="page-link">{{page}}</a>
            </li>
            <li [class.disabled]="!pager.hasNextPage">
                <a (click)="setPage(pager.currentPage + 1)" class="page-link">Next</a>
            </li>
            <li [class.disabled]="!pager.hasNextPage">
                <a (click)="setPage(pager.totalPages)" class="page-link">Last</a>
            </li>
        </ul>
    </div>
    <button class="float" (click)="openAddDialog()"><i class="fas fa-plus"></i></button>
</div>